import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_LetterRequestCustomer_Cancel, LetterRequestCustomer_Cancel } from 'src/app/Interface/LetterRequestCustomer_Cancel';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-LetterRequestCustomerScheduleSentence',
  templateUrl: './LetterRequestCustomerScheduleSentence.component.html',
  styleUrls: ['./LetterRequestCustomerScheduleSentence.component.scss']
})
export class LetterRequestCustomerScheduleSentenceComponent implements OnInit {
  Filter_Letter:string="0"
  Filter_Letter_Type:string="0"
  Filter_Customer:string=""
  Filter_Dsc:string=""
  BaseUrl3 = environment.BaseUrl + "Letterrequestcustomerprint/Mission?id="
  Procssing:boolean=false

  modalRef_Cancel: any;

  constructor(
    private LetterRequestCustomer_Service:LetterRequestCustomerService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_Schedules:Array<LetterRequestCustomer_Cancel>=[]
  Data_Seleted_Cancel:LetterRequestCustomer_Cancel=Empty_LetterRequestCustomer_Cancel()

  ngOnInit() {
    this.BaseUrl3=environment.BaseUrl + "Letterrequestcustomerprint/Mission?id="
    this.Nav_Service.CheckValidPage(1145).subscribe(
      data=>{

      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Schedules(){
    this.Procssing=true

    this.LetterRequestCustomer_Service.GetActiveMissionByLetter(Number(this.Filter_Letter)
      ,Number(this.Filter_Letter_Type)).subscribe(
      data=>{
        this.DataList_Schedules=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  set_Record(item:LetterRequestCustomer_Cancel)
  {
    this.Data_Seleted_Cancel=item
  }

  Close_Show_History(){
    this.Data_Seleted_Cancel=Empty_LetterRequestCustomer_Cancel()
  }


  SwichActivityDevice(item: LetterRequestCustomer_Cancel) {

    this.LetterRequestCustomer_Service
      .SwichActivityDsc(Number(item.code)).subscribe(
        data => {
          this.Alertify_Service.SuccessMessage("تغییرات اعمال شد")
          item.dscVisible=!item.dscVisible
        }
      )
  }

  SwichActivityVisible(item: LetterRequestCustomer_Cancel) {

    this.LetterRequestCustomer_Service
      .SwichActivityVisible(Number(item.code)).subscribe(
        data => {
          this.Alertify_Service.SuccessMessage("تغییرات اعمال شد")
          item.activityVisible=!item.activityVisible
        }
      )
  }

}
